import * as d3 from 'd3';
import { CASES_LINE_COLOR, DEATHS_LINE_COLOR } from '../constants';

const mapColorInterpolator = {
  minLightness: 0.95,
  maxLightness: 0.3,
  saturation: 0.65
};

const minMaxColors = (color, minLightness, maxLightness, saturation = undefined) => {
  const minColor = d3.hsl(color);
  minColor.l = minLightness;
  if (saturation !== undefined) {
    minColor.s = saturation
  }
  const maxColor = d3.hsl(color);
  maxColor.l = maxLightness;
  if (saturation !== undefined) {
    maxColor.s = saturation
  }
  return [minColor, maxColor]
};

export const casesColorInterpolator = () => {
  const [minColor, maxColor] = minMaxColors(CASES_LINE_COLOR, mapColorInterpolator.minLightness, mapColorInterpolator.maxLightness, mapColorInterpolator.saturation);
  return d3.interpolateHsl(minColor, maxColor);
};

export const deathsColorInterpolator = () => {
  const [minColor, maxColor] = minMaxColors(DEATHS_LINE_COLOR, mapColorInterpolator.minLightness, mapColorInterpolator.maxLightness, mapColorInterpolator.saturation);
  return d3.interpolateHsl(minColor, maxColor);
};

